import moment from "moment";
import React from "react";
import classes from './profileInfo.module.scss';
import { useNavigate } from "react-router-dom";
import { EmptySvg, LeftArrowSvg, RightArrowSvg } from "../../../constants/resources";

const DataList = (props: any) => {
    const { profile, setProfile, filterData } = props;
    const navigate = useNavigate()


    // debugger;
    const viewer = (node: any) => {


        const url = `v1/${node.key}`;

        // history.push({
        //     pathname: '/viewer',
        //     search: `?iid=${node.travelAnswer.key}&tid=${node.key}`
        // });
        navigate(url)
        // window.open(url);
    }

    function sortFun(a: any, b: any, prof: string) {

        if (profile === 'Past') {
            const aa = new Date(a.endDate).getTime()
            const bb = new Date(b.endDate).getTime()
            return bb - aa
        } else {
            const aa = new Date(a.startDate).getTime()
            const bb = new Date(b.startDate).getTime()
            return aa - bb
        }

    }
    // debugger;
    return <div >
        <div className={classes.flex} onClick={() => setProfile('Main')} >
            <LeftArrowSvg />
            <div className={classes.backButton}>Back</div>
        </div>
        {filterData.length > 0 ?
            <><div className={classes.DatalistTitleContainer}>
                <div className={classes.DataListTitle}>
                    {profile}
                </div>
            </div><div className={classes.DataListContainer}>

                    {filterData.sort((a: any, b: any) => (sortFun(a, b, profile))).map((node: any, idx: number) => {
                        return <div key={idx} onClick={() => viewer(node)} className={classes.Body}>

                            <div className={classes.box}>
                                <div className={classes.DataContainer}>

                                    {node?.media[1]?.url !== undefined ? <img alt="clear" className={classes.image} src={node?.media[1]?.url}></img>
                                        : null}

                                    <div className={classes.nameImageContainer}>
                                        <div className={classes.Itineraryname}>{node.name}</div>
                                        <div className={classes.ItineraryDuration}>{moment.utc(node?.startDate).format("MMMM DD yyyy")}{" "}-{" "}{moment.utc(node?.endDate).format("MMMM DD yyyy")}</div>
                                    </div>

                                </div>
                                <div className={classes.moreOptionIcon}>
                                    <RightArrowSvg />
                                </div>

                            </div>
                        </div>;
                    })}






                </div></>
            :
            <>
                <div className={classes.noDataMain}>
                    <div className={classes.noDataProfile}>
                        {profile}
                    </div>
                    <div className={classes.noDatasubhead}>
                        There are no “{profile}” itineraries at the moment
                        <div className={classes.noDataicon}>
                            <EmptySvg className={classes.noDataiconse} />
                        </div>
                    </div>
                </div>
            </>
        }
    </div>
}

export default DataList;